import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import contactUpdateDetails from './contactUpdateDetails';
import HistoryRecord from '@/app/components/onlineApproval/internalWorkFlow/history/historyRecord';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';

export default {
  name: 'contactUpdate',
  props: [
    'partyRowDetails',
    'urlSummaryData',
    'workflowId',
    'dashboardDetails'
  ],
  components: { contactUpdateDetails, HistoryRecord, ApprovalHistory },
  watch: {
    currentPage: function() {
      this.getVendorContactUpdateData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getVendorContactUpdateData();
    }
  },
  data() {
    return {
      vendorName: null,
      vendorCode: null,
      contactNumber: null,
      email: null,
      appStatus: {
        text: 'INPROCESS',
        value: 'INPROCESS'
      },

      totalRows: null,
      currentPage: 1,
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOptionSelectedInvoice(),
      isSuccess: false,
      responseMsg: '',
      showAlert: false,
      showValueSetModal: false,
      updateContactData: [],
      updateContactFields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'email',
          label: 'Email'
        },
        {
          key: 'mob',
          label: 'Mobile Number'
        },
        {
          key: 'department',
          label: 'Department'
        },
        {
          key: 'creation_date',
          label: 'Creation Date'
        },
        {
          key: 'approval_status',
          label: 'Approval Statuss'
        }
      ],
      showHideContactUpdateModalFlag: false,
      rowData: null,
      historyType: null,
      showHistory: false,
      recordId: null
    };
  },
  methods: {
    rowSelected(item) {
      this.rowData = item;
      this.showHideContactUpdateModalFlag = true;
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    selectedvalueSet(item) {
      if (
        this.vsetCode === appStrings.VALUESETTYPE.PARTY_REQ_APPROVAL_STATUS_VSET
      ) {
        this.appStatus = {
          text: item.value_meaning,
          value: item.value_code
        };
      }
    },
    clearFilters() {
      this.vendorName = null;
      this.vendorCode = null;
      this.contactNumber = null;
      this.email = null;
      this.appStatus = {
        text: 'INPROCESS',
        value: 'INPROCESS'
      };
    },
    clearVsetValues(value) {
      if (value === 'vendorCode') {
        this.vendorCode = null;
      } else if (value === 'vendorName') {
        this.vendorName = null;
      } else if (value === 'contactNumber') {
        this.contactNumber = null;
      } else if (value === 'email') {
        this.email = null;
      }
    },
    getVendorContactUpdateData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        party_name: this.vendorName,
        email: this.email,
        contact: this.contactNumber,
        approval_status: this.appStatus.value
      };
      this.loader = true;
      this.$store
        .dispatch('vendorUpdate/getVendorContactUpdateData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.updateContactData = resp.data.data.page;
            this.totalRows = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideBankUpdateModal(flag) {
      this.showHideContactUpdateModalFlag = flag;
    },
    showHideHistory(flag, historyType, type) {
      this.showHistory = flag;
      this.historyType = historyType;
      if (type == 'dropdown') {
        this.recordId = this.rowData.party_contact_req_update_id;
      }
    }
  }
};
